<template>
    <div class="form">
        <el-form style="margin:20px;width:75%;min-width:600px;" label-width="180px">
            <el-form-item class='edit-form' label="销售下单号">
                <span>{{Form.OrderCode}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="发货通知单号">
                <span>{{Form.SendCode}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="发货通知单状态" v-show="false">
                <span>{{Form.StatusName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="代理商">
                <span>{{Form.AgentName}} {{Form.AgentAddress}} {{Form.AgentTel}}</span>
            </el-form-item>
            <div v-show="orderTypeShow">
                <el-form-item class='edit-form' label="申请时间">
                    <span>{{Form.ApplyTime}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="期望上课日期">
                    <span>{{Form.StartDate}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="园所名称">
                    <span>{{Form.SchoolName}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="课程名称">
                    <span>{{Form.OrderTitle}}</span>
                </el-form-item>
                <el-form-item class='edit-form' label="观课人数" v-show="isShowGK">
                    <span>{{Form.Attendance}}</span>
                </el-form-item>
            </div>
            <el-form-item class='edit-form' label="发货通知单下单时间" v-show="false">
                <span>{{Form.SendTime}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="发货通知单下单人" v-show="false">
                <span>{{Form.SendUser}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="要求发货时间" v-show="false">
                <span>{{Form.RequireSendDate}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="实际发货时间">
                <span>{{Form.SendTime}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="实际签收时间">
                <span>{{Form.SignDate}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="发货通知单审核时间" v-show="false">
                <span>{{Form.AuditDate}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="幼儿数:">
                <span>{{Form.ChildNum}}</span>
            </el-form-item>
    
            <el-form-item label="开课申请表:">
                <el-row style="margin-left: 25px;" v-if="JSON.stringify(Form.ApplicationForm)!='[]'">
                    <el-col :span="3" v-for="item in Form.ApplicationForm" style="margin-right:25px;margin-top:10px">
                        <div style="width:100%;border:4px solid RGB(205,205,205);border-radius:3px;line-height:0px;">
                            <img :src="item.Url" style="width:100%;display:block" @click="viewpic(item.Url)">
                        </div>
                    </el-col>
                </el-row>
                <span v-else>--</span>
            </el-form-item>
    
            <el-form-item class='edit-form' label="套餐名称" v-show="Form.PackageName!=''">
                <span>{{Form.PackageName}}</span>
            </el-form-item>
    
            <el-form-item class='edit-form' label="发货情况" v-show="isShow">
                <el-radio-group style="width:300px;margin-left: 25px;" @change="SendStatus" v-model="SendGood">
                    <el-radio-button label="全部发货" value="1"></el-radio-button>
                    <el-radio-button label="部分发货" value="2"></el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item class='edit-form' label="商品" style="width:100%;" v-show="Form.ListGoods!=''">
                <el-table :data="Form.ListGoods" border style="width: 100%;  margin-left: 25px;">
                    <el-table-column prop="ProName" label="名称">
                    </el-table-column>
                    <el-table-column label="包含单品" width="240">
                        <template scope="scope">
                            <div v-if="scope.row.PackDetail.length==0">--</div>
                            <div v-else class="dpDvCtnCss">
                                <div class="dpDvCss" v-for="PackDetail in scope.row.PackDetail">{{ PackDetail.ProName}}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ProductNum" label="总数" v-if="isShow"></el-table-column>
                    <el-table-column prop="Nums" label="应发数" v-if="isShow"></el-table-column>
                    <el-table-column label="实发" width="200px">
                        <template scope="scope">
                            <el-input-number v-model="scope.row.ActualNum" :disabled="NumShow" :min="0" :max="getMaxNum(scope.row.Num)" size="small" style="display: flex;justify-content: center;"></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item class='edit-form' label="赠品" style="width:100%;" v-show="Form.GiftGoods!=''">
                <el-table :data="Form.GiftGoods" border style="width:100%;  margin-left: 25px;">
                    <el-table-column prop="ProName" label="名称">
                    </el-table-column>
                    <el-table-column label="包含单品" width="240">
                        <template scope="scope">
                            <div v-if="scope.row.PackDetail.length==0">--</div>
                            <div v-else class="dpDvCtnCss">
                                <div class="dpDvCss" v-for="PackDetail in scope.row.PackDetail">{{PackDetail.ProName}}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ProductNum" label="总数" v-if="isShow"></el-table-column>
                    <el-table-column prop="Nums" label="应发数" v-if="isShow"></el-table-column>
                    <el-table-column label="实发" width="200px">
                        <template scope="scope">
                            <el-input-number v-model="scope.row.ActualNum" :disabled="NumShow" :min="0" :max="scope.row.Num" size="small" style="display: flex;justify-content: center;"></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item class='edit-form' label="已发设备:" style="width:600px;" v-show="isShowIsFirst">
                <span> 55寸在线教室终端 {{Form.AgentConsignee}} </span>
            </el-form-item>
            <el-form-item class='edit-form w100' label="收货地址">
                <span>{{Form.AgentConsignee}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="收货人及联系方式">
                <span>{{Form.Consignee}}--{{Form.ConsigneeTel}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="寄送方式">
                <span>{{Form.SendModeName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="支付方式">
                <span>{{Form.PayModeName}}</span>
            </el-form-item>
            <el-form-item label="订单备注">
                <span>{{Form.OrderRemark}}</span>
            </el-form-item>
            <el-form-item label="财务审核备注">
                <span>{{Form.AuditRemark}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="快递或物流名称">
                <el-select placeholder="请选择" style="margin-left: 25px;width: 100px" v-model="AddForm.LogisticsId">
                    <el-option v-for="option in Logistics" :value="option.Id" :label="option.ParmName">
                    </el-option>
                </el-select>
                <el-button icon="plus" @click="showDialog"></el-button>
            </el-form-item>
            <el-form-item class='edit-form w100' label="快递或物流单号">
                <el-input placeholder="快递或物流单号" style="margin-left: 25px;width:50%" v-model="AddForm.LogisticsCode"></el-input>
            </el-form-item>
            <el-form-item class='edit-form w100' label="包裹件数">
                <el-input placeholder="包裹件数" style="margin-left: 25px;width:20%" v-model="AddForm.PackageNum"></el-input> 件
            </el-form-item>
            <el-form-item label="备注">
                <el-input type="textarea" style="margin-left: 25px;width:500px;" v-model="AddForm.Remark"></el-input>
            </el-form-item>
        </el-form>
        <el-row>
            <el-col :span="24" style='display:flex;justify-content:center;margin-bottom: 25px'>
                <el-button type="primary" :loading="submitFormLoad" @click="submitForm">确定</el-button>
            </el-col>
        </el-row>
        <el-dialog title="快递/物流管理" v-model="visibleShow" size="tiny" :close-on-click-modal="false" v-on:close="dialogClosed">
            <el-table :data="Logistics" style="width: 100%">
                <el-table-column prop="ParmName" label="名称" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template scope="scope">
                        <el-button size="small" icon="delete" type="danger" @click="delLogistics(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-row>
                    <el-col :span="16" style="margin-left: 20px">
                        <el-input v-model="dialogContent"></el-input>
                    </el-col>
                    <el-col :span="6">
                        <el-button type="primary" @click="addLogistics">添 加</el-button>
                    </el-col>
                </el-row>
            </span>
        </el-dialog>
        <div class="picshow">
            <el-dialog v-model="picVisible" size="tiny">
                <img :src="picUrl" alt="">
            </el-dialog>
        </div>
    </div>
</template>

<script>
import AddStockOutControl from './AddStockOutControl.js';

module.exports = AddStockOutControl;
</script>
<style scoped lang="scss">
span {
    margin-left: 25px;
}

.dpDvCss {
    border-bottom: 1px solid #ccc;
    line-height: 34px;
}

.dpDvCtnCss .dpDvCss:last-child {
    border: 0px!important;
}
</style>



// WEBPACK FOOTER //
// AddStockOut.vue?1d8dcfe1